<template>
    <v-card flat>
        <v-overlay :value="loadingNotificationCenterData">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-toolbar color="bal-gray" dense>
            <v-toolbar-title>{{
                activeNotification && activeNotification.id ? activeNotification.id : "-"
            }}</v-toolbar-title>
            <v-spacer />

            <v-btn icon @click="closeDrawer()">
                <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-tabs v-model="tab" background-color="bal-gray" color="bal-red">
            <v-tab style="text-transform: none !important;">
                {{ "General info" | t }}
            </v-tab>
            <v-tab-item>
                <general-view />
            </v-tab-item>
        </v-tabs>
    </v-card>
</template>

<script>
import { mapState } from "vuex";
import Store from "../../store";
import GeneralView from "@/pages/notification-center/views/general-view";

export default {
    components: { GeneralView },
    name: "notification-center-view",
    data() {
        return {
            isLoading: false,
            tab: 0
        };
    },
    async mounted() {
        document.addEventListener("keydown", this.handleKeyboardListener);
        const param = {
            id: this.$route.params.notificationId,
            type: this.$route.params.notificationType
        };
        await Store.dispatch("NotificationCenterStore/getNotificationData", param);
    },
    computed: {
        ...mapState("NotificationCenterStore", ["notifications", "activeNotification", "loadingNotificationCenterData"])
    },
    destroyed() {
        document.removeEventListener("keydown", this.handleKeyboardListener);
    },
    methods: {
        handleKeyboardListener(e) {
            if (e.keyCode === 27 || e.key === "Escape") this.closeDrawer();
            if (document.activeElement.tagName !== "INPUT" && (e.keyCode === 13 || e.key === "Enter")) {
                //this.saveNotification();
            }
        },
        closeDrawer() {
            this.$router.push({ name: "notification-center-list" });
        }
    }
};
</script>

<style scoped></style>
